import { CustomerStatus } from "../types/typescript-axios";

export const customerStatusToString = (status: CustomerStatus) => {
  return status === CustomerStatus.NUMBER_1 ? '仮会員'
    : status === CustomerStatus.NUMBER_2 ? '本会員'
    : '退会'
}
